// router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Body from '../components/body/BodyApp.vue'
import GestionCreditos from '../components/body/proyectos/GestionCreditos.vue'
import AhdecoStatic from '../components/body/proyectos/AhdecoStatic.vue'
import CatalogoAxum from '../components/body/proyectos/CatalogoAxum.vue'
import SasepStatic from '../components/body/proyectos/SasepStatic.vue'
import Security from '../components/security'

const routes = [
  // Landing
  { path: '/', name: 'Home', component: Body },

  // Secciones del landing sin hash (misma vista, hace scroll al id)
  { path: '/about-me',  name: 'About',     component: Body, meta: { scrollTo: '#about-me' } },
  { path: '/services',  name: 'Services',  component: Body, meta: { scrollTo: '#services' } },
  { path: '/portfolio', name: 'Portfolio', component: Body, meta: { scrollTo: '#portfolio' } },
  { path: '/contact',   name: 'Contact',   component: Body, meta: { scrollTo: '#contact' } },

    { path: '/gestion-creditos', name: 'GestionCreditos', component: GestionCreditos },
    { path: '/ahdeco-pagina-web', name: 'AhdecoStatic', component: AhdecoStatic },
    { path: '/catalogo-productos', name: 'CatalogoAxum', component: CatalogoAxum },
    { path: '/sasep-pagina-web', name: 'SasepStatic', component: SasepStatic },

]
const router = createRouter({
  history: createWebHistory(), // igual a tu versión
  routes,
  // Scroll sin hash: si la ruta tiene meta.scrollTo, hace scroll al selector
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return { ...savedPosition, behavior: 'smooth' }
    if (to.meta?.scrollTo) return { el: to.meta.scrollTo, behavior: 'smooth' }
    return { top: 0, behavior: 'smooth' }
  },
})

// corre en TODAS las navegaciones, como en tu ejemplo original
router.beforeEach(() => {
  Security.checkToken()
})

export default router
